import React from 'react';
import Slider from 'react-slick';
import image1 from '../assets/servicesImages/webdev/card1.png';
import image2 from '../assets/servicesImages/webdev/card2.png';
import image3 from '../assets/servicesImages/webdev/card3.png';
import image4 from '../assets/servicesImages/webdev/card4.png';
import image5 from '../assets/servicesImages/webdev/card5.png';
import image6 from '../assets/servicesImages/webdev/card6.png';

const process = [
    {
        image: image1,
        title: 'Discovery',
        type: '(Site specification, site plan)',
        desc: 'Defining goals, understanding the audience, and conducting competitive analysis...',
    },
    {
        image: image2,
        title: 'Information architecture',
        type: '(Images, Video, Text)',
        desc: 'Organize content and design intuitive navigation for seamless UX...',
    },
    {
        image: image3,
        title: 'Website & UI Design',
        type: '(Wireframes, Prototypes)',
        desc: 'Create user-friendly interfaces and responsive design...',
    },
    {
        image: image4,
        title: 'Website Launch',
        type: '(SEO, Testing, Analytics Setup)',
        desc: 'Test the website, optimize SEO, and launch for public access...',
    },
    {
        image: image5,
        title: 'Testing',
        type: '(Cross-browser, Device compatibility)',
        desc: 'Ensure proper functionality across devices and browsers...',
    },
    {
        image: image6,
        title: 'Website Deployment',
        type: '(Coding, Integration)',
        desc: 'Deploy the site after coding and integrating required functionalities...',
    },
];

const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    slidesToShow: 3, // Show 3 cards at a time
    speed: 500,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
        {
            breakpoint: 3000, // large screens default
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 1024, // md to lg
            settings: {
                slidesToShow: 3,
                centerMode: false,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                centerMode: false,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                centerMode: false,
            }
        }
    ]
};

const WebDevSection3 = () => {
    return (
        <div className="bg-gray-50 py-8 px-4">
            <div className="text-center mb-6">
                <p className="text-3xl font-semibold text-gray-800 mb-2">
                    Our Process
                </p>
                <p className="text-base text-gray-600 max-w-xl mx-auto">
                    Discover the simple steps we follow to create websites that balance functionality and user experience.
                </p>
            </div>

            <Slider {...settings} className="overflow-hidden">
                {process.map((p, index) => (
                    <div key={index} className="px-3">
                        <div className="w-full max-w-[270px] mx-auto bg-white rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 flex flex-col h-[300px] mb-5">
                            {/* Image */}
                            <img
                                src={p.image}
                                alt={p.title}
                                className="w-full h-[150px] object-cover rounded-t-lg"
                            />
                            <div className="flex flex-col justify-between p-4 h-full">
                                {/* Title */}
                                <p className="text-lg font-semibold text-gray-800">{p.title}</p>
                                <p className="text-xs text-gray-500">{p.type}</p>
                                {/* Description */}
                                <p className="text-sm text-gray-600 mt-2 flex-grow">{p.desc}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
}

export default WebDevSection3;
